import CircularProgress from '@mui/material/CircularProgress';
import { styled } from '@mui/material/styles';
import { ReactNode } from 'react';
import Checkbox from '@/components/Checkbox/Checkbox';
import ListItemButton from '@mui/material/ListItemButton';

const List = ({
  loading = false,
  items,
  values,
  mode,
  onChange,
  ref,
}: {
  loading?: boolean;
  items: {
    id: string | number;
    value: string | number;
    label: ReactNode;
  }[];
  values: (string | number)[];
  mode?: 'dark' | 'light';
  onChange: (values: (string | number)[]) => void;
  ref?: React.RefObject<HTMLDivElement | null>;
}) => {
  const handleToggle = (selectedId: string | number) => () => {
    const currentIndex = values.findIndex(
      (item) => item === selectedId,
    );
    const newChecked = [...values];

    if (currentIndex === -1) {
      newChecked.push(selectedId);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    onChange(newChecked);
  };

  return (
    <Root ref={ref}>
      {items.length > 0 ? (
        <StyledList
          sx={{ width: '100%' }}
          role="list"
          aria-label="Selectable items list"
        >
          {items.map(({ id, value: itemValue, label }) => (
            <StyledButton
              key={id}
              onClick={handleToggle(itemValue)}
              aria-label={`Toggle ${itemValue}`}
              role="checkbox"
            >
              <Checkbox
                checked={values.includes(itemValue)}
                mode={mode}
              />
              <Label>{label}</Label>
            </StyledButton>
          ))}
        </StyledList>
      ) : null}
      {loading && (
        <LoaderWrapper role="status" aria-label="Loading items">
          <CircularProgress />
        </LoaderWrapper>
      )}
    </Root>
  );
};

const Root = styled('div')(({ theme }) => ({
  maxHeight: 180,
  overflowY: 'auto',
  margin: `${theme.spacing(1)} 0`,
  flexShrink: 0,
}));

const LoaderWrapper = styled('div')({
  width: '100%',
  height: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
});

const StyledList = styled('div')({
  padding: 0,
});

const StyledButton = styled(ListItemButton)({
  padding: '4px 0',
});

const Label = styled('div')({
  fontSize: 14,
});

export default List;
